<template>
  <div :class="'border rounded-[8px] flex flex-col p-[24px] ' + containerClass">
    <div class="flex gap-[8px] items-center">
      <span
        v-if="prependTitleIcon"
        :class="`${prependTitleIcon}`"
        class="text-2xl"
      />
      <span :class="`${titleClass ? titleClass : 'text-[#333] text-lg font-medium'}`">{{ title }}</span>
      <span
        v-if="appendTitleIcon"
        v-b-tooltip.hover.top="tooltipText"
        :class="`${appendTitleIcon}`"
      />
    </div>
    <div :class="'font-semibold text-[20px] text-[#333] ' + contentClass">
      {{ content }}
    </div>
    <slot name="footer" />
  </div>
</template>

<script>
export default {
  props: {
    containerClass: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    prependTitleIcon: {
      type: String,
      default: '',
    },
    appendTitleIcon: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: '',
    },
  },
}
</script>
